import React, { Component, ReactNode } from 'react';
import getErrorDescription from './errorBoundaryHelper';
import ErrorBoundaryContainer from './ErrorBoundaryContainer';
import { Browser, isBrowserAllowed } from '../BrowserWarningNotification';

const MINUTE = 60000;

interface ErrorBoundaryProps {
  children: ReactNode;
  minBrowserVersions?: Record<Browser, number>;
  renderSupportAction?: (description: string) => ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  description: string;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = { hasError: false, description: '' };

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    this.setState({
      hasError: true,
      description: getErrorDescription(error, info),
    });

    setTimeout(() => window.location.reload(), MINUTE);
  }

  render() {
    const { hasError, description: errorDescription } = this.state;
    const { children, renderSupportAction, minBrowserVersions } = this.props;
    const isSupportedBrowser = minBrowserVersions ? isBrowserAllowed(minBrowserVersions) : true;

    const title = !isSupportedBrowser ? 'Page unavailable.' : 'An unexpected error has occurred.';
    const description = !isSupportedBrowser
      ? 'Your browser is outdated and not supported. Please, update your browser to continue using the application safely.'
      : 'If this continues to happen, contact DaVinci support via button below.';

    if (hasError) {
      return (
        <ErrorBoundaryContainer
          title={title}
          description={description}
          renderSupportAction={renderSupportAction}
          errorDescription={errorDescription}
        />
      );
    }

    return children;
  }
}

export default ErrorBoundary;
